import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const gardenBestPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#46b265]',
  COMMONS_FOOTER_BG: 'bg-[#46b265]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#46b265] hover:border-[#46b265] hover:bg-[#46b265] text-white ',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#46b265]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#46b265]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#46b265]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#46b265] text-[#46b265] [&>svg>path]:stroke-[#46b265] [&>svg>g>path]:stroke-[#46b265] [&>svg>path]:fill-[#46b265] [&>svg>g>path]:fill-[#46b265]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#46b265] text-[#46b265] [&>svg>path]:stroke-[#2f5132] [&>svg>g>path]:stroke-[#2f5132] [&>svg>path]:fill-[#2f5132] [&>svg>g>path]:fill-[#2f5132]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#46b265]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#46b265]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#46b265]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#46b265]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#46b265]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#14301c] [&>.vector-top>path]:fill-[#46b265] [&>.vector-bottom>path]:fill-[#46b265]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#14301c] [&>circle]:stroke-[#14301c] [&>path]:fill-[#46b265]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#2f5132] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#2f5132] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#2f5132]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#2f5132] [&_path]:fill-[#2f5132] [&_path]:stroke-[#2f5132]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#2f5132]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#2f5132]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#2f5132]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#2f5132]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#2f5132]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#14301c]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#14301c]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#14301c]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#14301c]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#46b265]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#46b265] text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#46b265]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#46b265]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#46b265]',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
}
